import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
};

export const SidebarOpenButton: React.FC<Props> = ({ onClick }: Props) => {
  const { t } = useTranslation();
  return (
    <button className="size-full focus:outline-none" onClick={onClick} aria-label={t('sidebar.container.openSidebar')}>
      <FontAwesomeIcon icon={faAngleDoubleRight} />
    </button>
  );
};
